import { connect } from 'react-redux'
import { showAlert } from '../utils/Alert'
import {
  fetchMaintenance,
  fetchLines,
  fetchTrains,
  fetchNotifications,
  fetchDisplayStationId,
  receiveStationId,
  receiveMaintenance,
  receiveLines,
  receiveTrainPosition,
  receiveNotification,
  fetchUserSettings,
  receiveUserSettings,
  putUserSettings,
  setUserSettings,
  lineReverse,
  nextNotification,
  receiveTrainIconSettings,
  fetchTrainIconSettings
} from '../actions'
import TrainPositionsApp from '../components/train_positions/TrainPositionsApp'

const mapStateToProps = state => {
  const { maintenance, lines, trains, notifications, showingOperation, nankai_update_date, nankai_update_time, koya_update_date, koya_update_time, station_id} = state.trainPositionReducer
  const { themeName } = state.themeReducer
  const { trainPositionAutoRefresh, popinfoId } = state.userSettingsReducer

  return {
    maintenance,
    lines,
    trains,
    notifications,
    showingOperation,
    nankai_update_date,
    nankai_update_time,
    koya_update_date,
    koya_update_time,
    themeName,
    trainPositionAutoRefresh,
    popinfoId,
    station_id,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchMaintenance: async () => {
      try {
        const payload = await fetchMaintenance()
        dispatch(receiveMaintenance(payload))
      } catch (error) {
        showAlert('メンテナンス情報が取得できませんでした')
      }
    },
    fetchNotifications: async () => {
      try {
        const payload = await fetchNotifications()
        dispatch(receiveNotification(payload))
      } catch (error) {
        showAlert('運行情報が取得できませんでした')
      }
    },
    fetchLines: async () => {
      try {
        const payload = await fetchLines()
        dispatch(receiveLines(payload))
      } catch (error) {
        showAlert('路線が取得できませんでした')
      }
    },
    fetchTrains: async () => {
      try {
        const payload = await fetchTrains()
        dispatch(receiveTrainPosition(payload))
      } catch (error) {
        showAlert('在線情報が取得できませんでした')
      }
    },
    fetchDisplayStationId: async (popinfoId) => {
      try {
        if (!popinfoId) {
          return true
        }
        const payload = await fetchDisplayStationId(popinfoId)
        dispatch(receiveStationId(payload))
      } catch (error) {
        showAlert('My駅を取得出来ませんでした。')
      }
    },
    fetchUserSettings: async (popinfoId) => {
      try {
        if (!popinfoId) {
          return true
        }
        const payload = await fetchUserSettings(popinfoId)
        dispatch(receiveUserSettings(payload))
      } catch (error) {
        showAlert('設定を取得できませんでした')
      }
    },
    changeTrainPositionAutoRefresh: async (popinfoId, enableAutoRefresh) => {
      try {
        const payload = {
          'train_position_auto_refresh': enableAutoRefresh
        }
        if (popinfoId) {
          await putUserSettings(popinfoId, payload)
        }
        dispatch(setUserSettings(payload))
      } catch (error) {
        showAlert('設定を更新できませんでした')
      }
    },
    lineReverse: () => {
      dispatch(lineReverse())
    },
    nextNotification: () => {
      dispatch(nextNotification())
    },
    fetchTrainIconSettings: async () => {
      try {
        const payload = await fetchTrainIconSettings()
        dispatch(receiveTrainIconSettings(payload))
      } catch (error) {
        //取得失敗した場合は何もしない。
      }
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrainPositionsApp)

